import styled from 'styled-components';
import HomeNavbar from '../components/homepage/HomeNavbar';
import { TableContainer } from '../styles';


const AuthWrapper = ({ children, title, subTitle, img }) => {

      return (
            <>
                  <HomeNavbar />
                  <Wrapper>
                        <section>
                              <div className="col-md-6">
                                    <div className="image">
                                          <div className="img-container">
                                                <img src={img} alt="Auth" />
                                          </div>
                                    </div>
                              </div>
                              <div className="col-md-6 mx-auto form-container">
                                    <div className="container">
                                          <div className="col-md-10 mx-auto mb-5">
                                                <div className="container">
                                                      <div className="text-center pry-text mt-5">
                                                            <h5>{title}</h5>
                                                            <small>{subTitle}</small>
                                                      </div>
                                                      <TableContainer>
                                                            <div className="light-bg br-md">
                                                                  <div className=" px-3 py-4 br-sm">
                                                                        {children}
                                                                  </div>
                                                            </div>
                                                      </TableContainer>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </section>
                  </Wrapper>
            </>
      );
};

export default AuthWrapper;


export const Wrapper = styled.main`
background: var(--sec-color);
min-height: 100vh;
padding-top:6.5rem;

section {
      display: flex;
      
      .image {
            padding-top:4.5rem;
            height: 100vh;
            width: 50%;
            position: fixed;
            top: 0;
            left: 0;
            background-color: var(--sec-bold-color);
            overflow: hidden !important;
            z-index: 1 ;
            
            .img-container{
                  position: relative;
                  width:auto;
                  height:100vh;
                  display: flex;
                  align-items:center;
                  justify-content: center;
                  img {
                        border-radius: 1rem;
                        width: 100%;
                        /* height:100%; */
                        margin:auto;
                        object-fit:cover;
                  }
            }
      }

      .form-container{
            /* overflow: scroll !important; */
      }
      
      @media screen and (max-width: 768px) {
            .image {
                  display:none;
            }
      }
}

.form {
  margin-top: 2rem;
  padding: 2rem 0;
}

.toggle-eye {
  position: absolute;
 right: 5%;
  top: 6%;
  cursor: pointer;
  font-weight: bolder;
  font-size: 2rem;
}

.toggle-eye svg {
    font-size: 22px !important;
    color: var(--grey-bold-color);
}
`;